import React, { useEffect, useCallback, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const Link = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Local state to manage the token, success state, and other flags
  const [linkToken, setLinkToken] = useState(null);
  const [isItemAccess, setIsItemAccess] = useState(false);
  const [linkSuccess, setLinkSuccess] = useState(false);
  const [isPaymentInitiation, setIsPaymentInitiation] = useState(false);
  const [isCraProductsExclusively, setIsCraProductsExclusively] = useState(false);

  // Retrieve linkToken from location.state or localStorage
  useEffect(() => {
    const tokenFromLocation = location.state?.link_token;
    const tokenFromStorage = localStorage.getItem("link_token");

    if (tokenFromLocation) {
      setLinkToken(tokenFromLocation);
      localStorage.setItem("link_token", tokenFromLocation);
    } else if (tokenFromStorage) {
      setLinkToken(tokenFromStorage);
    }
  }, [location]);

  // Callback to handle success
  const onSuccess = useCallback(
    (public_token) => {
      const exchangePublicTokenForAccessToken = async () => {
        try {
          const response = await axios.post(
            "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/account-list",
            { 
              publicToken: public_token,
              phoneNumber:localStorage.getItem("phone")
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          // const { access_token, item_id } = response.data;
          // console.log("data: ",response.data)
          localStorage.setItem("token",public_token)

          
          // Update state with access token and item_id
          setIsItemAccess(true);
          setLinkSuccess(true);

          // Optionally, save tokens in localStorage if needed
          // localStorage.setItem("access_token", access_token);
          // localStorage.setItem("item_id", item_id);
          navigate('/pages/select-account')
        } catch (error) {
          console.error("Error exchanging public token:", error);
          setIsItemAccess(false);
        }
      };

      // Handle different cases based on product type
      if (isPaymentInitiation || isCraProductsExclusively) {
        setIsItemAccess(false);
      } else {
        exchangePublicTokenForAccessToken();
      }

      // Set success state and redirect if needed
      setLinkSuccess(true);
      window.history.pushState("", "", "/");
    },
    [isPaymentInitiation, isCraProductsExclusively]
  );

  // Plaid Link config
  const config = {
    token: linkToken,
    onSuccess,
  };

  let isOauth = false;
  if (window.location.href.includes("?oauth_state_id=")) {
    config.receivedRedirectUri = window.location.href;
    isOauth = true;
  }

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (ready) {
      open(); // Automatically trigger the Plaid Link when ready
    }
  }, [ready, open]);

  return null; // No need for a button anymore, automatically triggered
};

export default Link;
